import { Chip } from "@mui/material";
import PropTypes from "prop-types";

const StatusChip = ({ status, colors }) => {
  const { background, text } = colors[status] || colors.Default;
  return (
    <Chip
      label={status}
      size="small"
      sx={{
        fontWeight: "bold",
        background: background,
        color: text || "white",
        width: "103px",
      }}
    />
  );
};

StatusChip.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusChip;
